export default "__VITE_PUBLIC_ASSET__87a8f6c7__"